import { useEffect, useState } from 'react';

import { productionApi } from 'api/production';

/**
 * Fetches and manages aisle banners.
 *
 * @returns {Object} - Hook return object
 * @returns {boolean} loading - Whether the banners are loading
 * @returns {Array} banners - The list of banners
 * @returns {Function} refetch - Function to manually refetch banners
 * @returns {Function} refetch.silent - Pass true to refetch without updating loading state
 */
export function useBanners() {
    const [loading, setLoading] = useState(true);
    const [banners, setBanners] = useState();

    const fetchBanners = async (silent = false) => {
        try {
            if (!silent) {
                setLoading(true);
            }

            const response = await productionApi.getAisleBanners();
            setBanners(response.data?.rows);
        } catch (error) {
            console.error('Error fetching banners:', error);
        } finally {
            if (!silent) {
                setLoading(false);
            }
        }
    };

    const refetch = (silent) => {
        fetchBanners(silent);
    };

    useEffect(() => {
        fetchBanners();
    }, []);

    return { banners, loading, refetch };
}
